import { fetchActionWrapper } from 'barnyard/utils';
import * as types from '../constants';


const formFieldFetches = fetchActionWrapper({
  LIST_ACTION: types.BUYER_FETCH_FORM_FIELDS
});

const formFields = (state = {}, action) => {
  switch (action.type) {
    case types.BUYER_FETCH_FORM_FIELDS.success:
      return action.result;
    default:
      return state;
  }
};

export {
  formFields,
  formFieldFetches
};
